import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import Select from "react-select"
import { SectionContext } from "../../context/sectionContext"
import { ErrorContext } from "../../context/errorContext"
import {JourneyContext} from "../../context/journeyContext"
import { ConditionContext } from "../../context/conditionContext"
import { getValueFromJourney } from "../../services/helperFunctions"
import { lineCapital } from "../../../shared/functions"
import * as lookup from "../../../../static/lookup.json"
import { RepeatableContext } from "../../context/repeatableContext"
import { auto } from "async"

const SelectContainer = styled.div`
  display: block;
  flex-direction: column;
  margin: 14px 0;
  position: relative;
  box-sizing: border-box;
  font-size: 15px;
  color: #505050;
  float: left;
  min-width: 100%;
  max-width: 100%;

  & > .css-2b097c-container {
    margin-top: -17px;

    & div.css-1pahdxg-control{
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"} !important;
      background: var(--lumiq-bg) !important;
    }
    
    & > div {
      border-radius: 0;
      border: 1px solid #929292;
      padding: 0.6rem 0;
      padding-bottom: 0;
    }

    .css-1uccc91-singleValue{
      color:inherit;
      font-size: 1rem;
    }

    & div.css-yk16xz-control{
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
      background: var(--lumiq-bg);

      .css-1hb7zxy-IndicatorsContainer > div{
        padding: 0 !important;
        padding-right: 4px !important;    
      }
    }
    .css-1gtu0rj-indicatorContainer{
      padding: 0 !important;
      padding-right: 4px !important;
    }
    
    & > div.css-26l3qy-menu {
      z-index: 500 !important;
      background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
      background:var(--lumiq-bg)

    }

    & > div {
      box-shadow: none !important;
      border: 1px solid #929292;
    }
    & .css-1okebmr-indicatorSeparator {
      background: transparent;
    }
  }

  & > label {
    margin-left: 8px;
    margin-bottom: 5px;
    color: #505050;
    font-size: 16px;
    background: ${props => props.channel === "A" || props.channel === "28" || props.channel === "35" || props.channel === "39" ? "#ededed" : "#fff"};
    background: var(--lumiq-bg);
    padding: 2px 5px;
    z-index: 1;
    position: relative;
    display: inline-block;
    cursor: default;
  }
`
// const customStyles = {
//   option: (provided) => ({
//     ...provided,
//     // padding: 0,
//     zIndex:9999
//   }),
//   control: () => ({
//     // display:'flex'
//     // none of react-select's styles are passed to <Control />
//   }),
//   input:()=>({

//   }),
//   singleValue: (provided, state) => {
//     // const opacity = state.isDisabled ? 0.5 : 1;
//     // const transition = 'opacity 300ms';

//     // return { ...provided, opacity, transition };
//   }
// }

export default function RepeatableComponentTextSelect(props) {
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [errorState, setErrorState] = useContext(ErrorContext)
  const [repeatableState,setRepeatableState] = useContext(RepeatableContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [showLocalError, setShowLocalError] = useState(false)
  const [conditionState, setConditionState] = useContext(ConditionContext)

  const validate = (target) =>  {
    let temp
    let temp1
    if (errorState[props.data.formControlKey]) {
      temp1 = errorState[props.data.formControlKey]
    }else{
      temp1 = []
    }
    if (props.data.required) {
    //   required field validation
      if(!sectionState.sectionData[props.data.formControlKey] || !sectionState.sectionData[props.data.formControlKey][props.index]){
        // console.log("dchdh1", props, sectionState)
        temp1[props.index] =  (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState( prev => {
            return ({
            ...prev,
            [props.data.formControlKey]: temp
            })
        })
        return 
      }
      if((sectionState.sectionData[props.data.formControlKey]) && (!sectionState.sectionData[props.data.formControlKey][props.index])){
        temp1[props.index] = (getValueFromJourney(
              journeyState.lookup.required_error,
              props.data.requiredError
            ))
        temp = temp1
        setErrorState( prev => {
          // console.log("dchdh2", props, sectionState)
          return ({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }else{
        temp1[props.index] = ""
        temp = temp1
        setErrorState(prev => {
          // console.log("dchdh3", props, sectionState)
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
      temp1[props.index] = ""
      temp = temp1
      if(target.value){
        // console.log("dchdh4", props, sectionState)
        setErrorState(prev => {
          return({
            ...prev,
            [props.data.formControlKey]: temp
          })
        })
      }
    }
    if ("causeOfDeath" == props.data.formControlKey) {
      let setTemp
      let changeTemp
      let familyMemberValue
      let changeFamilyMember
      let aliveOrDeceased
      let setaliveOrDeceased
      let ifdeceased
      let setifdeceased
      if (errorState["causeOfDeath"]) {
        changeTemp = errorState["causeOfDeath"]
      } else {
        changeTemp = []
      }
      if (errorState["aliveOrDeceased"]) {
        aliveOrDeceased = errorState["aliveOrDeceased"]
      } else {
        aliveOrDeceased = []
      }
      // if (errorState["ifDeseased"]) {
      //   ifdeceased = errorState["ifDeseased"]
      // } else {
      //   ifdeceased = []
      // }
      if (errorState["familyMemberHealthLA"]) {
        familyMemberValue = errorState["familyMemberHealthLA"]
      } else {
        familyMemberValue = []
      }
      if (target.value) {
        if (!sectionState.sectionData["causeOfDeath"] == "") {
          changeTemp[props.index] = ""
          setTemp = changeTemp
          setErrorState(prev => {
            return ({
              ...prev,
              ["causeOfDeath"]: setTemp
            })
          })
          if (!sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') || sectionState.sectionData['familyMemberHealthLA'][props.index] == undefined||sectionState.sectionData['familyMemberHealthLA'][props.index] == "") {
            familyMemberValue[props.index] = "Please select Family Member"
            changeFamilyMember = familyMemberValue
             setErrorState(prev => {
              return ({
                ...prev,
                ["familyMemberHealthLA"]: changeFamilyMember
              })
            })
          }
          if (!sectionState.sectionData.hasOwnProperty('aliveOrDeceased') || sectionState.sectionData['aliveOrDeceased'][props.index] == undefined || sectionState.sectionData['aliveOrDeceased'][props.index] == "") {

            aliveOrDeceased[props.index] = "Please enter Alive/Deceased"
            setaliveOrDeceased = aliveOrDeceased
            setErrorState(prev => {
              return ({
                ...prev,
                ["aliveOrDeceased"]: setaliveOrDeceased
              })
            })
          }
          // if (!sectionState.sectionData.hasOwnProperty('ifDeseased') || sectionState.sectionData['ifDeseased'][props.index] == undefined || sectionState.sectionData['ifDeseased'][props.index] == "") {
          //   ifdeceased[props.index] = "Please enter Age at Death"
          //   setifdeceased = ifdeceased
          //    setErrorState(prev => {
          //     return ({
          //       ...prev,
          //       ["ifDeseased"]: setifdeceased
          //     })
          //   })
          // }
        }
      }
      else {
        // if (sectionState.sectionData.hasOwnProperty('ifDeseased')&&sectionState.sectionData["ifDeseased"][props.index]) {

        //   changeTemp[props.index] = "Please enter cause of death"
        //   setTemp = changeTemp
        //   setErrorState(prev => {
        //     return ({
        //       ...prev,
        //       ["causeOfDeath"]: setTemp
        //     })
        //   })
        // }
       
        familyMemberValue[props.index] = ""
        changeFamilyMember = familyMemberValue
        setErrorState(prev => {
          return ({
            ...prev,
            ["familyMemberHealthLA"]: changeFamilyMember
          })
        })
      }
      // setShowLocalError(true)
      return
    }
    if (props.data.formControlKey === "aliveOrDeceased") {
      let setTemp
      let changeTemp
      let aliveOrDeceased
      let setaliveOrDeceased
      let familyMemberValue
      let changeFamilyMember
      let ifAlive
      let setifAlive
      let ifdeceased
      let setifdeceased
      let causeOfDeath
      let setCauseofDeath
      if (errorState["aliveOrDeceased"]) {
        aliveOrDeceased = errorState["aliveOrDeceased"]
      } else {
        aliveOrDeceased = []
      }
      if (errorState["ifAlive"]) {
        ifAlive = errorState["ifAlive"]
      } else {
        ifAlive = []
      }
      if (errorState["ifDeseased"]) {
        ifdeceased = errorState["ifDeseased"]
      } else {
        ifdeceased = []
      }
      if (errorState["causeOfDeath"]) {
        causeOfDeath = errorState["causeOfDeath"]
      } else {
        causeOfDeath = []
      }
      if (errorState["familyMemberHealthLA"]) {
        familyMemberValue = errorState["familyMemberHealthLA"]
      } else {
        familyMemberValue = []
      }
      if (target.value) {
        if (!sectionState.sectionData["aliveOrDeceased"] == "") {
          aliveOrDeceased[props.index] = ""
          setaliveOrDeceased = aliveOrDeceased
          setErrorState(prev => {
            return ({
              ...prev,
              ["aliveOrDeceased"]: setaliveOrDeceased
            })
          })
          if (!sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') || sectionState.sectionData['familyMemberHealthLA'][props.index] == undefined||sectionState.sectionData['familyMemberHealthLA'][props.index] == "") {
            familyMemberValue[props.index] = "Please select Family Member"
            changeFamilyMember = familyMemberValue
             setErrorState(prev => {
              return ({
                ...prev,
                ["familyMemberHealthLA"]: changeFamilyMember
              })
            })
          }
        }
        // let tempEmpty
        // if(target.value === "alive"){
        //   let temp1Empty = []
        //   temp1Empty[props.index] = ""
        //   tempEmpty = temp1Empty
        //   setSectionState((prev) => {
        //     return ({
        //       ...prev,
        //       sectionData: {
        //         ...prev.sectionData,
        //         ["ifDeseased"]: tempEmpty,
        //         ["causeOfDeath"]: tempEmpty
        //       },
        //     })
        //   })
        // }
        // if(target.value === "deceased"){
        //   let temp1Empty = []
        //   temp1Empty[props.index] = ""
        //   tempEmpty = temp1Empty
        //   setSectionState((prev) => {
        //     return ({
        //       ...prev,
        //       sectionData: {
        //         ...prev.sectionData,
        //         ["ifAlive"]: tempEmpty
        //       },
        //     })
        //   })
        // }
        if (target.value === "alive" && sectionState.sectionData.hasOwnProperty('ifAlive')&& !sectionState.sectionData["ifAlive"][props.index]) {

          ifAlive[props.index] = "Please enter Current Age"
          setifAlive = ifAlive
          setErrorState(prev => {
            return ({
              ...prev,
              ["ifAlive"]: setifAlive
            })
          })
        }
        if (target.value === "deceased") {

          ifAlive[props.index] = ""
          setifAlive = ifAlive
          setErrorState(prev => {
            return ({
              ...prev,
              ["ifAlive"]: setifAlive
            })
          })
        }
        if (target.value === "alive") {
          ifdeceased[props.index] = ""
          setifdeceased = ifdeceased
          causeOfDeath[props.index] = ""
          setCauseofDeath = causeOfDeath
          setErrorState(prev => {
            return ({
              ...prev,
              ["causeOfDeath"]: setCauseofDeath,
              ["ifDeseased"]: setifdeceased
            })
          })
        }
        if (target.value === "deceased" && sectionState.sectionData.hasOwnProperty('ifDeseased')&& !sectionState.sectionData["ifDeseased"][props.index]) {

          ifdeceased[props.index] = "Please enter Age at Death"
          setifdeceased = ifdeceased
          setErrorState(prev => {
            return ({
              ...prev,
              ["ifDeseased"]: setifdeceased
            })
          })
        }
        if (target.value === "deceased" && sectionState.sectionData.hasOwnProperty('causeOfDeath')&& !sectionState.sectionData["causeOfDeath"][props.index]) {

          causeOfDeath[props.index] = "Please enter Cause at Death"
          setCauseofDeath = causeOfDeath
          setErrorState(prev => {
            return ({
              ...prev,
              ["causeOfDeath"]: setCauseofDeath
            })
          })
        }
      }
      // else {
      //   familyMemberValue[props.index] = ""
      //   changeFamilyMember = familyMemberValue
      //   setErrorState(prev => {
      //     return ({
      //       ...prev,
      //       ["familyMemberHealthLA"]: changeFamilyMember
      //     })
      //   })
      // }
      // setShowLocalError(true)
      return
    }
    if (props.data.formControlKey === "familyMemberHealthLA") {
      let setTemp
      let changeTemp
      let changeTempvalue
      let setTempValue
      if (errorState["aliveOrDeceased"]) {
        changeTempvalue = errorState["aliveOrDeceased"]
      } else {
        changeTempvalue = []
      }
      if (errorState["familyMemberHealthLA"]) {
        changeTemp = errorState["familyMemberHealthLA"]
      } else {
        changeTemp = []
      }
      if (target.value && props.data.formControlKey === "familyMemberHealthLA") {
        if (!sectionState.sectionData["familyMemberHealthLA"] == "") {
          changeTemp[props.index] = ""
          setTemp = changeTemp
          setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: setTemp
            })
          })
        }
        if (!sectionState.sectionData.hasOwnProperty('aliveOrDeceased') || sectionState.sectionData['aliveOrDeceased'][props.index] == undefined || sectionState.sectionData['aliveOrDeceased'][props.index] == "") {
          changeTempvalue[props.index] = "Please enter Alive/Deceased"
          setTempValue = changeTempvalue
          setErrorState(prev => {
            return ({
              ...prev,
              ["aliveOrDeceased"]: setTempValue
            })
          })
        }
        // if((!sectionState.sectionData.hasOwnProperty('ifAlive') && !sectionState.sectionData.hasOwnProperty('ifDeseased')) ||( sectionState.sectionData.hasOwnProperty('ifAlive') && !sectionState.sectionData["ifAlive"][props.index] &&
        // sectionState.sectionData.hasOwnProperty('ifDeseased') && !sectionState.sectionData["ifDeseased"][props.index])){
        //   changeTempvalue[props.index] = "Please enter the details for Family Member"
        //   setTempValue = changeTempvalue
        //   setErrorState(prev => {
        //     return ({
        //       ...prev,
        //       ["familyMemberDetails"] : setTempValue
        //     })
        //   })
        // } else {
        //   setErrorState(prev => {
        //     return ({
        //       ...prev,
        //       ["familyMemberDetails"]: ""
        //     })
        //   })
        // }
      }
      else {
        if (sectionState.sectionData.hasOwnProperty('familyMemberHealthLA') && sectionState.sectionData["familyMemberHealthLA"][props.index]) {
          changeTemp[props.index] = "Please select Family Member"
          setTemp = changeTemp
          setErrorState(prev => {
            return ({
              ...prev,
              ["familyMemberHealthLA"]: setTemp
            })
          })
        }
      }
      // setShowLocalError(true)
      return
    }
  }

  useEffect(() => {
    validate({value: (sectionState.sectionData[props.data.formControlKey]? sectionState.sectionData[props.data.formControlKey][props.index] ?? "" : "")})
    if(props.data.formControlKey === "nomineeFullNameTitle" && sectionState.sectionData?.["nomineeFullNameTitle"] && sectionState.sectionData["nomineeFullNameTitle"][props.index]){
      autoFill({value: sectionState.sectionData["nomineeFullNameTitle"][props.index] })
    }
    if(props.data.formControlKey === "nomineeTitle" && sectionState.sectionData?.["nomineeTitle"] && sectionState.sectionData["nomineeTitle"][props.index]){
      autoFill({value: sectionState.sectionData["nomineeTitle"][props.index] })
    }
  },[sectionState.sectionData[props.data.formControlKey]?.[props.index]])

  
  useEffect(() => {
    if(!sectionState.sectionData[props.data.formControlKey]?.[props.index]){
      // For Iselect Plans
      if((props.data.formControlKey === "contactCountryCode") || (props.data.formControlKey === "AlternateMobCountryCode") ){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "+91"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "+91"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
      }else if(props.data.formControlKey.toLowerCase().includes("country") && props.sectionId !== "SectionFlexiEdgeFillProposalNomineeDetails"){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "IN"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "IN"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
          }
        })
      }else if((props.data.formControlKey === "nomineeFullNameTitle")){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "MR"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "MR"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
          }
        })
      }

      // For CPF plan
      // else if(props.data.formControlKey === "nomineeTitle"){
      //   let temp
      //   if (sectionState.sectionData[props.data.formControlKey]) {
      //     let temp1 = sectionState.sectionData[props.data.formControlKey]
      //     temp1[props.index] = "MR"
      //     temp = temp1
      //   }else{
      //     let temp1 = []
      //     temp1[props.index] = "MR"
      //     temp = temp1
      //   }
      //   setSectionState((prev) => {
      //     return ({
      //       ...prev,
      //       sectionData: {
      //         ...prev.sectionData,
      //         [props.data.formControlKey]: temp
      //       },
      //     })
      //   })
      //   setConditionState(prev => {
      //     return {
      //       ...prev,
      //       [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
      //     }
      //   })
      // }
      else if(props.data.formControlKey === "nomineeCountryCode" && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "+91"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "+91"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
      }
      else if(props.data.formControlKey === "nomineeCountry" && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
        let temp
        if (sectionState.sectionData[props.data.formControlKey]) {
          let temp1 = sectionState.sectionData[props.data.formControlKey]
          temp1[props.index] = "IN"
          temp = temp1
        }else{
          let temp1 = []
          temp1[props.index] = "IN"
          temp = temp1
        }
        setSectionState((prev) => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              [props.data.formControlKey]: temp
            },
          })
        })
        setConditionState(prev => {
          return {
            ...prev,
            [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
          }
        })
      }

      
    }
  }, [props.sectionId])

  const handleChange = target => {
    if (sectionState.sectionId === props.sectionId) {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = target.value;
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = target.value
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
        }
      })
    } else {
      let temp
      if (sectionState.sectionData[props.data.formControlKey]) {
        let temp1 = sectionState.sectionData[props.data.formControlKey]
        temp1[props.index] = target.value;
        temp = temp1
      }else{
        let temp1 = []
        temp1[props.index] = target.value
        temp = temp1
      }
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: props.sectionId,
          sectionData: {
            ...prev.sectionData,
            [props.data.formControlKey]: temp,
          },
        }
      })
      setConditionState(prev => {
        return {
          ...prev,
          [`${props.pageId}.${props.sectionId}.${props.data.formControlKey}`]: temp,
        }
      })
    }
    validate(target)
    console.log(sectionState, "section state")
  }


  const autoFill = (target) => {
    // For iselect Plan nominee detail section
    if(props.data.formControlKey.toLowerCase().includes("country") && props.sectionId === "nomineeDetailsSection"){
      //Temp Indexes will be used either in if or else
      
      let temp = JSON.parse(JSON.stringify(repeatableState["nomineePersonalDetail"]))
      let nominee = JSON.parse(JSON.stringify(temp[props.index]))

      if (sectionState.sectionData[props.data.formControlKey][props.index] !== "IN") {
        let tempState
        if (sectionState.sectionData["state"]) {
          let temp1 = sectionState.sectionData["state"]
          temp1[props.index] = "NR";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = "NR"
          tempState = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["state"]: tempState,
            }
          })
        })
        nominee.components[12]["min_len"] = 1
        nominee.components[12]["max_length"] = 9
        nominee.components[12]["regex"] = "/^[a-zA-Z0-9]+$/"
        nominee.components[12]["__typename"] = "ComponentCmpTagTextString"
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
      } else {
        let tempState
        if (sectionState.sectionData["state"]) {
          let temp1 = sectionState.sectionData["state"]
          temp1[props.index] = "";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = ""
          tempState = temp1
        }

        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["state"]: tempState,
            }
          })
        })

        nominee.components[12]["min_len"] = 6
        nominee.components[12]["regex"] = null
        nominee.components[12]["__typename"] = "ComponentCmpTagNumber"
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
      }
    }else if(props.data.formControlKey === "nomineeFullNameTitle"){
      let gender
      let relationshipLookup
      if(sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR"){
        gender = "M"
        relationshipLookup = "nomineeRelationshipWithLAMale"
      }else if (sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MS" || sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MRS"){
        gender = "F"
        relationshipLookup = "nomineeRelationshipWithLAFemale"
      }
      if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index] === "T"){
        gender = "T"
        relationshipLookup = "nomineeRelationshipWithLA"
      }
      console.log(repeatableState, "asff")
      let tempState
        if (sectionState.sectionData["gender"]) {
          let temp1 = sectionState.sectionData["gender"]
          temp1[props.index] = gender
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = gender
          tempState = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["gender"]: tempState,
            }
          })
        })
        if(errorState["gender"] && errorState["gender"][props.index]){
          let temp
          let temp1 = errorState["gender"]
          temp1[props.index] = ""
          temp = temp1
          setErrorState( prev => {
            return ({
              ...prev,
              ["gender"]: temp
            })
          })
          // if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index]){
          //   if(sectionState.sectionData["gender"][props.index] === "M" && sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR")
          // }
        }
        
        let temp = JSON.parse(JSON.stringify(repeatableState.nomineePersonalDetail))
        console.log(temp, "before")
        let nominee = JSON.parse(JSON.stringify(temp[props.index]))
        console.log(nominee, "Nbefore")
        // nominee.components[4]["disabled"] = true
        nominee.components[3]["lookupKey"] = relationshipLookup
        console.log(nominee, "Nafter")
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["nomineePersonalDetail"]: temp
          })
        })
    }
    // For CPF Nominee detail section
    else if(props.data.formControlKey === "nomineeCountry" && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
      //Temp Indexes will be used either in if or else
      
      let temp = JSON.parse(JSON.stringify(repeatableState["proposalFormNomineeDetails"]))
      let nominee = JSON.parse(JSON.stringify(temp[props.index]))

      if (sectionState.sectionData[props.data.formControlKey][props.index] !== "IN") {
        let tempState
        if (sectionState.sectionData["stateNominee"]) {
          let temp1 = sectionState.sectionData["stateNominee"]
          temp1[props.index] = "NR";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = "NR"
          tempState = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["stateNominee"]: tempState,
            }
          })
        })
        nominee.components[13]["min_len"] = 1
        nominee.components[13]["max_length"] = 9
        nominee.components[13]["regex"] = "/^[a-zA-Z0-9 ]+$/"
        nominee.components[13]["min_len_error"] = "N0010"
        nominee.components[13]["max_len_error"] = "M0017"
        nominee.components[13]["regexError"] = "E256"
        nominee.components[13]["__typename"] = "ComponentCmpTagTextString"
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["proposalFormNomineeDetails"]: temp
          })
        })
      } else {
        let tempState
        if (sectionState.sectionData["stateNominee"]) {
          let temp1 = sectionState.sectionData["stateNominee"]
          temp1[props.index] = "";
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = ""
          tempState = temp1
        }

        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["stateNominee"]: tempState,
            }
          })
        })

        nominee.components[13]["min_len"] = 6
        nominee.components[13]["regex"] = null
        nominee.components[13]["min_len_error"] = "N0002"
        nominee.components[13]["max_len_error"] = "M0002"
        nominee.components[13]["regexError"] = null
        nominee.components[13]["__typename"] = "ComponentCmpTagNumber"
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["proposalFormNomineeDetails"]: temp
          })
        })
      }
    }
    else if(props.data.formControlKey === "nomineeTitle"){
      let gender
      let relationshipLookup
      let martialStatus = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.martialStatus"]
      if(sectionState.sectionData["nomineeTitle"]?.[props.index] === "MR"){
        gender = "M"
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }else if (sectionState.sectionData["nomineeTitle"]?.[props.index] === "MS" || sectionState.sectionData["nomineeTitle"]?.[props.index] === "MRS"){
        gender = "F"
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAFemale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAFemaleUnMarried"
        }
      }else{
        // by default gender selected is M
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }
      if(sectionState.sectionData["nomineeGender"] && sectionState.sectionData["nomineeGender"]?.[props.index] === "T"){
        gender = "T"
        relationshipLookup = "nomineeRelationshipWithLA"
      }
      console.log(repeatableState, "asff")
      let tempState
        if (sectionState.sectionData["nomineeGender"]) {
          let temp1 = sectionState.sectionData["nomineeGender"]
          temp1[props.index] = gender
          tempState = temp1
        } else {
          let temp1 = []
          temp1[props.index] = gender
          tempState = temp1
        }
        setSectionState(prev => {
          return ({
            ...prev,
            sectionData: {
              ...prev.sectionData,
              ["nomineeGender"]: tempState,
            }
          })
        })
        if(errorState["nomineeGender"] && errorState["nomineeGender"][props.index]){
          let temp
          let temp1 = errorState["nomineeGender"]
          temp1[props.index] = ""
          temp = temp1
          setErrorState( prev => {
            return ({
              ...prev,
              ["nomineeGender"]: temp
            })
          })
          // if(sectionState.sectionData["gender"] && sectionState.sectionData["gender"][props.index]){
          //   if(sectionState.sectionData["gender"][props.index] === "M" && sectionState.sectionData["nomineeFullNameTitle"][props.index] === "MR")
          // }
        }
        if(sectionState.sectionData["nomineeRelationshipWithUser"] && sectionState.sectionData["nomineeRelationshipWithUser"][props.index] && !Object.keys(lookup[relationshipLookup][0]).includes(sectionState.sectionData["nomineeRelationshipWithUser"][props.index])){
          let tempState
          if (sectionState.sectionData["nomineeRelationshipWithUser"]) {
            let temp1 = sectionState.sectionData["nomineeRelationshipWithUser"]
            temp1[props.index] = ""
            tempState = temp1
          } else {
            let temp1 = []
            temp1[props.index] = ""
            tempState = temp1
          }
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["nomineeRelationshipWithUser"]: tempState,
              }
            })
          })
        }
        
        let temp = JSON.parse(JSON.stringify(repeatableState.proposalFormNomineeDetails))
        console.log(temp, "before")
        let nominee = JSON.parse(JSON.stringify(temp[props.index]))
        console.log(nominee, "Nbefore")
        // nominee.components[4]["disabled"] = true
        nominee.components[3]["lookupKey"] = relationshipLookup
        console.log(nominee, "Nafter")
        temp[props.index] = nominee
        console.log(temp, "after")
        setRepeatableState(prev => {
          return ({
            ...prev,
            ["proposalFormNomineeDetails"]: temp
          })
        })
    }
  }

  useEffect(() => {
    if (props.data.formControlKey === "nomineeTitle" && props.sectionId === "SectionFlexiEdgeFillProposalNomineeDetails"){
      let relationshipLookup
      let martialStatus = conditionState["PageFlexiEdgeFillProposalForm.SectionFlexiEdgeFillProposalPersonalDetail.martialStatus"]
      if(sectionState.sectionData["nomineeTitle"]?.[props.index] === "MR"){
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }else if (sectionState.sectionData["nomineeTitle"]?.[props.index] === "MS" || sectionState.sectionData["nomineeTitle"]?.[props.index] === "MRS"){
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAFemale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAFemaleUnMarried"
        }
      }else{
        // by default gender selected is M
        if (martialStatus === "M"){
          relationshipLookup = "nomineeRelationshipWithLAMale"
        }else{
          relationshipLookup = "nomineeRelationshipWithLAMaleUnMarried"
        }
      }
      
      if(sectionState.sectionData["nomineeGender"] && sectionState.sectionData["nomineeGender"]?.[props.index] === "T"){
        relationshipLookup = "nomineeRelationshipWithLA"
      }

      setTimeout(() => {
        if(!Object.keys(lookup[relationshipLookup][0]).includes(sectionState?.sectionData?.["nomineeRelationshipWithUser"]?.[props.index]) && relationshipLookup.includes("UnMarried")){
          let tempState
          console.info("inside")
          if (sectionState.sectionData["nomineeRelationshipWithUser"]) {
            let temp1 = sectionState.sectionData["nomineeRelationshipWithUser"]
            temp1[props.index] = ""
            tempState = temp1
          } else {
            let temp1 = []
            temp1[props.index] = ""
            tempState = temp1
          }
          
          setSectionState(prev => {
            return ({
              ...prev,
              sectionData: {
                ...prev.sectionData,
                ["nomineeRelationshipWithUser"]: tempState,
              }
            })
          })
          
        }
      },500)

      let temp = repeatableState.proposalFormNomineeDetails
      console.info(temp, "before")
      let nominee = JSON.parse(JSON.stringify(temp[props.index]))
      console.log(nominee, "Nbefore")
      // nominee.components[4]["disabled"] = true
      nominee.components[3]["lookupKey"] = relationshipLookup
      console.log(nominee, "Nafter")
      temp[props.index] = nominee
      console.log(temp, "after")
      setRepeatableState(prev => {
        return ({
          ...prev,
          ["proposalFormNomineeDetails"]: temp
        })
      })

    }
  }, [props.sectionId])
  

  // const getSelectedValue = () => {
  //   let key = Object.keys(props.options).filter(function(key) {return props.options[key] === sectionState.sectionData[props.data.formControlKey] })[0];
  //   console.log(key,"dhbe")
  //   return key
  // }
  function getKeyByValue(object, value) {
    return object.find(key => key.value == value)
  }
  let options = props.options
  options = Object.entries(options).map(([key, val]) => ({
    value: key,
    label: val,
  }))
  return (
    <>
      <SelectContainer channel={props.channel} className={`input-container ${props.data.disabled?'disable-input':''} ${props.data?.freeze?'freeze-input':''}` }>
        <label htmlFor={props.data.label} className="input-label">
        {(getValueFromJourney(
          journeyState.lookup.label,
          props.data.label
        )) || props.data.label}
        </label>
        <Select
          // className="form-control"
          // styles={customStyles}
          options={options}
          name={props.data.label}
          key={props.data.formControlKey}
          id="InputSelect"
          required={props.data.required}
          disabled={props.data.disabled}
          onChange={handleChange}
          tabIndex={props.data.disabled || props.data?.freeze?-1:0}
          // value={
          //   sectionState.sectionData[props.data.formControlKey]
          //     ? getKeyByValue(
          //         options,
          //         sectionState.sectionData[props.data.formControlKey]
          //       )
          //     : ""
          // }
          value={
            sectionState.sectionData[props.data.formControlKey] &&  sectionState.sectionData[props.data.formControlKey][props.index]
              ? getKeyByValue(
                  options,
                  sectionState.sectionData[props.data.formControlKey][props.index]
                )
              : ""
          }
          onBlur={e => autoFill(e.target)}
        ></Select>
        <span className="input-error2">
        {(props.showError || showLocalError) && (
            Array.isArray(errorState?.[props.data.formControlKey])
              ? errorState?.[props.data.formControlKey]?.[props.index]
              : errorState?.[props.data.formControlKey]
          )
          }
        </span>
      </SelectContainer>
    </>
  )
}
